import React from "react";

import { HubButton } from "../inputs";
import { HubContextMenu } from "../HubContextMenu";
import PrinterList from "./PrinterList";

const defaultProps = {
  variant: "contained",
  size: "xsmall",
  color: "neutral",
};

export const ZplPrintButton = ({
  buttonProps = defaultProps,
  label = "Print Barcodes",
  getZplString = () => {},
  customMenuButton,
}) => {
  const MENU_BUTTON = customMenuButton || (
    <HubButton label={label} {...buttonProps} />
  );

  return (
    <HubContextMenu
      id="barcode_printing"
      menuButton={MENU_BUTTON}
      IconButtonProps={{ sx: { padding: "0px !important" } }}
      HubIconProps={{ size: 14 }}
      MenuProps={{ sx: { ".MuiList-root": { padding: "0px !important" } } }}
    >
      <PrinterList getZpl={getZplString} />
    </HubContextMenu>
  );
};

export default ZplPrintButton;
